// Constantes & formats du grand volet Tournées de soin (Prompt 7, Phase 3).
export const STATUT_LABEL = { brouillon: "Brouillon", active: "Active", terminee: "Terminée", annulee: "Annulée" };
export const STATUT_CLR = {
  brouillon: { bg: "#f1f1ed", fg: "#4a5060" },
  active: { bg: "oklch(0.93 0.05 250)", fg: "oklch(0.45 0.14 255)" },
  terminee: { bg: "oklch(0.93 0.05 155)", fg: "oklch(0.4 0.12 155)" },
  annulee: { bg: "#fde8e8", fg: "#b42318" },
};
export const PART_LABEL = {
  a_contacter: "À contacter", contacte: "Contacté", interesse: "Intéressé", a_valider: "À valider",
  a_rappeler: "À rappeler", info_demandee: "Info demandée", rdv_valide: "RDV validé",
  liste_attente: "Liste d'attente", sans_reponse: "Sans réponse", pas_interesse: "Pas intéressé", desinscrit: "Désinscrit",
};
const AMBRE = { dot: "oklch(0.7 0.13 75)", bg: "oklch(0.96 0.04 75)", fg: "oklch(0.42 0.1 75)" };
const GRIS = { dot: "#9199ab", bg: "#f1f1ed", fg: "#4a5060" };
export const PART_CLR = {
  a_valider: AMBRE, a_rappeler: AMBRE,
  rdv_valide: { dot: "oklch(0.6 0.12 155)", bg: "oklch(0.95 0.04 155)", fg: "oklch(0.38 0.1 155)" },
  // « À contacter » bleu pastel (Prompt 10 §B.3)
  a_contacter: { dot: "oklch(0.7 0.09 245)", bg: "oklch(0.96 0.03 245)", fg: "oklch(0.45 0.1 245)" },
  // « Intéressé » turquoise pour ne pas confondre avec « À contacter »
  interesse: { dot: "oklch(0.65 0.1 195)", bg: "oklch(0.96 0.03 195)", fg: "oklch(0.42 0.08 195)" },
  info_demandee: { dot: "oklch(0.55 0.16 300)", bg: "oklch(0.95 0.04 300)", fg: "oklch(0.42 0.14 300)" },
  liste_attente: { dot: "oklch(0.7 0.05 80)", bg: "oklch(0.96 0.015 80)", fg: "#4a3a10" },
  contacte: GRIS, sans_reponse: GRIS, pas_interesse: GRIS, desinscrit: GRIS,
};
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
// Palette pastel de la barre de progression compacte (Prompt 8 §A.2)
export const STEP_COLORS = {
  brouillon: { dot: "#9a8f78", bg: "oklch(0.955 0.02 80)", fg: "#4a3f2a", line: "oklch(0.86 0.03 80)" },
  active: { dot: "oklch(0.62 0.13 255)", bg: "oklch(0.95 0.035 255)", fg: "oklch(0.4 0.11 255)", line: "oklch(0.8 0.07 255)" },
  terminee: { dot: "oklch(0.62 0.13 155)", bg: "oklch(0.95 0.04 155)", fg: "oklch(0.38 0.1 155)", line: "oklch(0.8 0.08 155)" },
  annulee: { dot: "oklch(0.62 0.16 25)", bg: "oklch(0.955 0.03 25)", fg: "oklch(0.48 0.14 25)", line: "oklch(0.85 0.06 25)" },
};
// Temps relatif lisible (« il y a 3 h », « hier », « il y a 4 j »)
export const relTime = (d) => {
  if (!d) return "";
  const dt = new Date(d); if (isNaN(dt)) return "";
  const diff = (Date.now() - dt.getTime()) / 1000;
  if (diff < 60) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  const j = Math.floor(diff / 86400);
  if (j === 1) return "hier";
  if (j < 7) return `il y a ${j} j`;
  return frDate(d, false);
};
export const frDate = (d, weekday = true) => {
  if (!d) return ""; const dt = new Date(d); if (isNaN(dt)) return "";
  return cap(dt.toLocaleDateString("fr-FR", { weekday: weekday ? "short" : undefined, day: "numeric", month: "short", year: "numeric" }));
};
export const frDateTime = (d) => { if (!d) return ""; const dt = new Date(d); if (isNaN(dt)) return ""; return cap(dt.toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" })) + " · " + dt.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }); };
export const frRange = (a, b) => {
  if (!a && !b) return "—";
  if (a && b && a.slice(0, 10) !== b.slice(0, 10)) {
    const da = new Date(a), db = new Date(b);
    const sa = da.toLocaleDateString("fr-FR", { weekday: "short", day: "numeric" });
    const sb = db.toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
    return `${cap(sa)} et ${cap(sb)}`;
  }
  return frDate(a || b);
};
// Formatage unique des jours d'une tournée (Prompt 10 §C.1). Accepte des chaînes ou {date}.
export const formatDatesTournee = (jours) => {
  const ds = [...new Set((jours || []).map((j) => ((typeof j === "string" ? j : j?.date) || "").slice(0, 10)))].filter(Boolean).sort();
  if (!ds.length) return "";
  const dts = ds.map((s) => new Date(s + "T00:00:00"));
  const wd = (dt) => cap(dt.toLocaleDateString("fr-FR", { weekday: "short" }));
  const day = (dt) => dt.getDate();
  const month = (dt, short) => dt.toLocaleDateString("fr-FR", { month: short ? "short" : "long" });
  const first = dts[0], last = dts[dts.length - 1];
  const sameMonth = first.getMonth() === last.getMonth() && first.getFullYear() === last.getFullYear();
  const consecutive = dts.every((dt, i) => i === 0 || dt - dts[i - 1] === 86400000);
  if (dts.length === 1) return `${wd(first)} ${day(first)} ${month(first)}`;
  if (dts.length === 2 && consecutive) return `${wd(first)} ${day(first)} et ${wd(last)} ${day(last)} ${month(last)}`;
  if (consecutive) {
    if (sameMonth) return `Du ${wd(first)} ${day(first)} au ${wd(last)} ${day(last)} ${month(last)}`;
    return `Du ${wd(first)} ${day(first)} ${month(first, true)} au ${wd(last)} ${day(last)} ${month(last, true)}`;
  }
  const parts = dts.map((dt) => `${wd(dt)} ${day(dt)}${sameMonth ? "" : " " + month(dt, true)}`);
  const tail = parts.pop();
  return parts.join(", ") + " et " + tail + (sameMonth ? ` ${month(last)}` : "");
};
// Énumère toutes les dates (YYYY-MM-DD) entre debut et fin incluses, à partir d'aujourd'hui.
// Arithmétique de dates en chaîne (aucune conversion UTC) pour éviter tout décalage de fuseau.
const _pad = (n) => String(n).padStart(2, "0");
export const todayStr = () => { const d = new Date(); return `${d.getFullYear()}-${_pad(d.getMonth() + 1)}-${_pad(d.getDate())}`; };
export const addDays = (dateStr, n) => { const [y, m, d] = dateStr.slice(0, 10).split("-").map(Number); const dt = new Date(y, m - 1, d); dt.setDate(dt.getDate() + n); return `${dt.getFullYear()}-${_pad(dt.getMonth() + 1)}-${_pad(dt.getDate())}`; };
export const enumJours = (jours, debut, fin) => {
  const explicit = (jours || []).map((j) => ((typeof j === "string" ? j : j?.date) || "").slice(0, 10)).filter(Boolean);
  if (explicit.length) return [...new Set(explicit)].sort();
  const a = (debut || "").slice(0, 10), b = (fin || "").slice(0, 10);
  if (!a || !b) return [a, b].filter(Boolean);
  const today = todayStr();
  const out = []; let cur = a < today ? today : a; let guard = 0;
  while (cur <= b && guard++ < 400) { out.push(cur); cur = addDays(cur, 1); }
  return out;
};
// Créneaux candidats d'une journée : pas de 30 min sur matin (09-12) et après-midi (14-18).
export const genCreneaux = (date) => {
  const slots = [];
  for (const [h0, h1] of [[9, 12], [14, 18]]) {
    for (let m = h0 * 60; m < h1 * 60; m += 30) {
      const hh = _pad(Math.floor(m / 60)); const mm = _pad(m % 60);
      slots.push({ heure: `${hh}:${mm}`, iso: `${date}T${hh}:${mm}`, plage: h0 < 13 ? "Matin" : "Après-midi" });
    }
  }
  return slots;
};
